<template>
  <v-app>
    <app-bar v-if="$store.state.appReady && (!$route.meta || !$route.meta.hideNavbar)" :showDrawer.sync="showDrawer"/>
    <navigation-drawer v-if="$store.state.axios && $store.state.appReady && (!$route.meta || !$route.meta.hideNavbar)"
                       v-model="showDrawer"/>
    <v-main>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
    <v-footer v-if="$store.state.loading">
      <v-progress-linear color="info" indeterminate/>
    </v-footer>
    <error-dialog v-if="$store.state.appReady"/>
    <unauthorized-dialog v-if="$store.state.appReady && $store.state.axios"/>
    <share-access-dialog v-if="$store.state.axios"/>
    <snackbar-app/>
    <interrupt-snackbar-app v-if="$store.state.appReady && $store.state.axios"/>
    <emergency-logout-dialog v-if="$store.state.appReady && $store.state.axios"/>
    <survey-dialog v-if="$store.state.appReady && $store.state.axios"/>
    <availabilities-expired-info-dialog v-if="$store.state.appReady && $store.state.axios"/>

    <v-slide-x-reverse-transition>
      <action-button/>
    </v-slide-x-reverse-transition>
    <cookie-banner/>
    <div style="z-index: 999">
      <portal-target multiple name="overlay"/>
    </div>
    <footer>
      <vanilla-footer/>
    </footer>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import AppBar from '@/components/app/app-bar.app.vue';
import CookieBanner from '@/components/app/cookieBanner.app.vue';
import SurveyDialog from '@/components/app/surveyDialog.vue';
import {ClientHooks} from '@/hooks';

export default Vue.extend({
  name: 'App',
  components: {
    AvailabilitiesExpiredInfoDialog: () => import('@/components/app/infoDialogs/availabilitiesExpiredInfoDialog.vue'),
    VanillaFooter: () => import('@/components/common/vanillaFooter.vue'),
    CookieBanner,
    InterruptSnackbarApp: () => import('@/components/app/interrupt-snackbar-app.vue'),
    EmergencyLogoutDialog: () => import('@/components/app/emergency-logout-dialog.vue'),
    NavigationDrawer: () => import('@/components/app/navigation-drawer.app.vue'),
    AppBar,
    ErrorDialog: () => import('@/components/app/error-dialog.app.vue'),
    UnauthorizedDialog: () => import('@/components/app/unauthorized-dialog.app.vue'),
    SnackbarApp: () => import('@/components/app/snackbar.app.vue'),
    ActionButton: () => import('@/components/app/action-button.app.vue'),
    ShareAccessDialog: () => import('@/components/app/share-access-dialog.vue'),
    SurveyDialog,
  },
  data: () => ({
    showDrawer: false,
  }),
  watch: {
    '$vuetify.breakpoint.mdAndUp'(v: boolean) {
      this.$nextTick(() => {
        this.showDrawer = v;
      });
    },
  },
  async mounted() {
    await ClientHooks.init();
    if (this.$vuetify.breakpoint.mdAndUp) {
      this.showDrawer = true;
    }
  },
});
</script>

<style src="./global.css"/>
